import {createHttpClient} from '@/services/HttpService';
import type {BackendServiceName} from '@/services/HttpService/backendServices';

// ID-token client for every wrapper in this folder; HttpClient holds no per-request state.
export const backend = createHttpClient('BACKEND');

// App Check instead of an ID token, for audit records from callers without the employee claim.
export const appCheckBackend = createHttpClient('BACKEND', 'appcheck');

// The running flavor's own public API; shared routes are mounted on both so no app calls the other's.
export const ownPublicApi = (): BackendServiceName => {
  const flavor = process.env.VUE_APP_FLAVOR;
  if (flavor === 'internal') return 'internal-public-api';
  if (flavor === 'external') return 'external-public-api';
  throw new Error(`VUE_APP_FLAVOR must be "internal" or "external" to pick a backend, got "${flavor}".`);
};
